import { render, staticRenderFns } from "./CreditGrantedTable.vue?vue&type=template&id=ec18531a"
import script from "./CreditGrantedTable.vue?vue&type=script&lang=js"
export * from "./CreditGrantedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports